import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { BehaviorSubject, Observable } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';

@Component({
    selector: 'app-meli-attributes',
    templateUrl: './meli-attributes.component.html',
    styleUrls: ['./meli-attributes.component.scss'],
    standalone: false
})
export class MeliAttributesComponent implements OnInit {

  constructor(@Inject(NZ_MODAL_DATA) public dialogData, private http:HTTPService,private uid:UserAuthenticationServices,
  private cd:ChangeDetectorRef, public dialogRef:NzModalRef<any>) { }

  result = [];
  resultOb = new BehaviorSubject<Object>(null);
  // flag do nz-spin (ex-ngx-spinner 'attribspinner')
  loading = false;
  ngOnInit(): void {
      
      let ob = {
        codeCompany : this.dialogData['CODECOMPANY']!=null? this.dialogData['CODECOMPANY']:this.uid.user.codecompany,
        method: 'GET',
        serviceName: 'GetItem',
      }

    
      ob['params'] = [{key:'@MLB', value: this.dialogData['id']}];

      this.loading = true;
      this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(result=>{
          this.result = result['resultado'];
          this.resultOb.next(this.result);
          this.loading = false;
          this.cd.markForCheck();
      },error=>{
         this.loading = false;
         this.cd.markForCheck();
      });


  }

}
